import "@fortawesome/fontawesome-svg-core/styles.css";
import "./style.css";

import { all } from "@awesome.me/kit-698d8619ec/icons";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
import { defaultConfig as formkitDefaultConfig, plugin as formkit } from "@formkit/vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Settings } from "luxon";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";

import formkitConfig from "./formkit.config.js";
import messages from "@intlify/unplugin-vue-i18n/messages";

import App from "./App.vue";

import { resetAndClearPersistedPlugin } from "./pinia/plugins/reset-persisted-state.js";
import { router } from "./routes.ts";

Settings.defaultLocale = Intl.DateTimeFormat(window.navigator.languages).resolvedOptions().locale;

const i18n = createI18n({
  legacy: false,
  locale: navigator.language,
  fallbackLocale: "en-AU",
  messages,
});

library.add(...all);

const storage = sessionStorage;

const pinia = createPinia();
pinia.use(
  createPersistedState({
    storage: storage,
  }),
);

pinia.use(resetAndClearPersistedPlugin(storage));

const app = createApp(App)
  .use(router)
  .use(pinia)
  .use(i18n)
  .use(autoAnimatePlugin)
  .use(formkit, formkitDefaultConfig(formkitConfig))
  .component("font-awesome-icon", FontAwesomeIcon);

app.mount("#app");
